import { render, staticRenderFns } from "./MediaCard.vue?vue&type=template&id=09692c52&scoped=true&"
import script from "./MediaCard.vue?vue&type=script&lang=ts&"
export * from "./MediaCard.vue?vue&type=script&lang=ts&"
import style0 from "./MediaCard.vue?vue&type=style&index=0&id=09692c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09692c52",
  null
  
)

export default component.exports